import { render, staticRenderFns } from "./EditResellerInvoicePage.vue?vue&type=template&id=318eb4f2"
import script from "./EditResellerInvoicePage.vue?vue&type=script&lang=js"
export * from "./EditResellerInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports